import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  filter,
  finalize,
  of,
  switchMap,
  take,
} from 'rxjs';
import { ContractService } from 'src/app/modules/services/contracts/contract.service';
import { LoadingService } from '../../loading/loading.service';
import { AlertComponent } from '../../alert/alert.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { EntitiesService } from 'src/app/modules/services/entities/entities.service';
import { StatesService } from 'src/app/modules/services/states/states.service';
import { OpenSnackbarService } from 'src/app/modules/services/snackBar/open-snackbar.service';
import { HttpClient } from '@angular/common/http';
import { ConcessaoService } from 'src/app/modules/services/concessao/concessao.service';
import { SercretariasService } from 'src/app/modules/services/secretarias/sercretarias.service';
import { DocumentosService } from 'src/app/modules/services/documentos/documentos.service';
import { ModalComponent } from '../../modal/modal.component';
import { UploadModalComponent } from 'src/app/modules/shared/modals/upload-modal/upload-modal.component';
import { AnotacoesService } from 'src/app/modules/services/anotacoes/anotacoes.service';
import { MatTabGroup } from '@angular/material/tabs';
import { IntervenientesService } from 'src/app/modules/services/intervenientes/intervenientes.service';
import { Location } from '@angular/common';
import { AddIntervenientesModalComponent } from '../add-intervenientes-modal/add-intervenientes-modal.component';
import { AuthService } from 'src/app/modules/services/auth/auth.service';
import { UserService } from 'src/app/modules/services/user/user.service';
import { ModalHistoricComponent } from 'src/app/modules/shared/modals/modal-historic/modal-historic.component';
import { ModalController } from '@ionic/angular';
import { ToastService } from 'src/app/modules/services/toast/toast.service';

@Component({
  selector: 'app-edit-contract',
  templateUrl: './edit-contract.component.html',
  styleUrls: ['./edit-contract.component.scss'],
})
export class EditContractComponent implements OnInit, AfterViewInit {
  intervenientesList: any[] = [];
  anotacoesList: any[] = [];
  concessionType: string = '';
  contract: any;
  contract_id!: string | null ;
  searchControlTipoEntidadeIntervenientes = new FormControl();
  panelOpen: boolean = true;
  pageSize: number = 10;
  pageIndex: number = 0;
  totalPages: number = 0;
  totalElements: number = 0;
  sortState: any = { sortProperty: 'criadoEm', sortDirection: 'desc' };
  dataSourceEntitieTable = new MatTableDataSource<any>([]);
  dataSourceIntervenientsTable = new MatTableDataSource<any>([]);
  @ViewChild('paginatorIntervenientes', { static: false })
  paginatorIntervenientes!: MatPaginator;
  @ViewChild('paginatoranotation', { static: false })
  paginatoranotation!: MatPaginator;
  @ViewChild('paginatorDocument', { static: false })
  paginatorDocument!: MatPaginator;
  descricao: any = '';
  @ViewChild(MatTabGroup) tabGroup!: MatTabGroup;
  searchControlEntidadeIntervenientes = new FormControl();
  displayedColumnsEntities: string[] = [
    'perfil',
    'razaoSocial',
    'cnpj',
    'status',
    'actions',
  ];
  displayedColumnsIntervenientes: string[] = [
    'perfil',
    'razaoSocial',
    'cnpj',
    'status',
    'actions',
  ];
  displayedColumnsDocuments: string[] = [
    'tipo',
    'description',
    'anexo',
    'actions',
  ];
  pageIndexDocument: number = 0;
  pageSizeDocument: number = 10;
  totalPagesDocument: number = 1;
  totalElementsDocument: number = 0;
  sortStateDocument: any = { sortProperty: 'criadoEm', sortDirection: 'desc' };
  dataSourceEntitieTableDocument = new MatTableDataSource<any>([]);
  dataSourceAnnotation = new MatTableDataSource<any>([]);
  displayedColumnsAnotation: string[] = ['description', 'actions'];
  pageIndexAnotation: number = 1;
  pageSizeAnotation: number = 10;
  totalPagesAnotation: number = 1;
  totalElementsAnotation: number = 0;
  filteredOptionsTipoEntidadeIntervenientes: any[] = [];
  filteredOptionsEntidadeIntervenientes: any[] = [];
  filteredOptionsContractTypes: any[] = [];
  filteredOptionsConcessionTypes: any[] = [];
  filteredOptionsSecretarias: any[] = [];
  selectedOption: any;
  selectedOptionTipoEntidadeIntervenientes: any;
  selectedOptionEntidadeIntervenientes: any;
  selectedOptionContractType: any;
  selectedOptionConcessionType: any;
  selectedOptionSecretary: any;
  screenWidth: number = 0;
  screenHeight: number = 0;
  selectedTabIndex: number = 0;
  selectedTabParametrosIndex: number = 0;
  selectedTabRelatorioIndex: number = 0;
  selectedTabRelatoriosIndex: number = 0;
  readonly TYPE_RODOVIARIOS: string = 'Rodoviária';
  onInit:boolean = false;
  buttonInclusaoDisabled: boolean = false;
  buttonExclusaoDisabled: boolean = false;
  buttonEdicaoDisabled: boolean = false;
  temDetalhes: boolean = false;
  fileChanged: boolean = false;
  prazosForm!: FormGroup;

  constructor(
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private entitiesService: EntitiesService,
    private loadingService: LoadingService,
    private contractService: ContractService,
    private cdr: ChangeDetectorRef,
    private _snackBar: MatSnackBar,
    private annotationService: AnotacoesService,
    private documentServices: DocumentosService,
    private intervienteService: IntervenientesService,
    private location: Location,
    private authService: AuthService,
    private userService: UserService,
    private modalCtrl: ModalController,
    private toastService: ToastService,
    private router: Router,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
    this.prazosForm = this.fb.group({
      prazoAnaliseFuncional: [null],
      prazoAnaliseExecutivo: [null],
    });

    this.route.paramMap.subscribe((params) => {
      this.contract_id = params.get('id');

      this.onGetContract(this.contract_id);
      this.onGetIntervenier(this.contract_id);
      this.onGetAllAnotation();
      this.getDocuments();
      this.getPrazoAnaliseProjeto();
    });
    this.temDetalhes = this.router.url.includes('detalhes');
    this.entitiesService.getEntities().subscribe((results:any) =>{
      this.filteredOptionsEntidadeIntervenientes = results.content;
    })
      this.entitiesService.getEntitiesTypes().subscribe((results:any) =>{
        this.filteredOptionsTipoEntidadeIntervenientes = results;
      })
    this.getScreenDimensions();
    window.addEventListener('resize', this.getScreenDimensions.bind(this));
    this.loadUserInfo();
  }

  loadUserInfo() {
    const userId = this.authService.getUserIdFromToken();
    if (userId) {
      this.userService.getMenuUsuario(userId).subscribe((response: any) => {
        const functionalities = response.profileUser.permissaoPerfis;

        functionalities.forEach((permission: any) => {
          this.checkFunctionality(permission.funcionalidade);
        });
      });
    }
  }

  checkFunctionality(functionality: any) {

    if (functionality.url === '/contratos') {
      this.handleRestrictions(functionality.restricoes);
    }

    if (functionality.subFuncionalidades && functionality.subFuncionalidades.length > 0) {
      functionality.subFuncionalidades.forEach((subFunctionality: any) => {
        this.checkFunctionality(subFunctionality);
      });
    }
  }

  handleRestrictions(restrictions: any[]) {
    restrictions.forEach((restriction: { nome: any; }) => {
      switch (restriction.nome) {
        case 'Inclusão':
          this.buttonInclusaoDisabled = true;
          break;
        case 'Exclusão':
          this.buttonExclusaoDisabled = true;
          break;
        case 'Edição':
          this.buttonEdicaoDisabled = true;
          break;
      }
    });
  }

  getScreenDimensions() {
    this.screenWidth = window.innerWidth;
    this.screenHeight = window.innerHeight;
  }

  pageChangeEventEntitie(event: PageEvent) {
    if (this.pageIndex !== event.pageIndex) {
      this.onGetEntitiesIntervenientes(event.pageIndex);
    }
  }

  onGetEntitiesIntervenientes(pageIndex: number = 0) {
    // this.loadingService.showLoading();
  }
  openSnackBar(description: string, type: string) {
    let classSnack = '';
    switch (type) {
      case 'sucess':
        classSnack = 'snacbar-sucess';
        break;
      case 'warning':
        classSnack = 'snacbar-warning';
        break;
      case 'error':
        classSnack = 'snacbar-error';
        break;
    }
    this._snackBar.openFromComponent(AlertComponent, {
      duration: 3000,
      panelClass: [classSnack, 'snackbar-custom'],
      data: { description: description, type: type },
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });
  }

  back() {
    this.router.navigate([`contrato/${this.contract_id}/editar`]);
    
  }
  close(){
    this.router.navigate([`contratos`]);
  }
  updatedIntervenientes() {
    let data = {
      isEditMode: false
    }
    const dialog = this.dialog.open(AddIntervenientesModalComponent, {
      panelClass: ['filter-panel'],
      data
    })
    dialog.afterClosed().subscribe({
      next: (res: any) => {
        if(res){
          this.intervienteService
          .addIntervenientes(res, this.contract_id)
          .pipe(
            take(1),
            finalize(() => {
              this.loadingService.hideLoading();
            })
          )
          .subscribe({
            next: (res: any) => {
              this.openSnackBar(res.message, 'sucess');
              this.onGetIntervenier(this.contract_id);

            },
            error: (erro: any) => {
              if (erro.status !== 500 && erro.status) {
                return this.openSnackBar(erro.error.message, 'error');
              }
              if (erro.error.error == 'Unprocessable Entity') {
                return this.openSnackBar(erro.error.message, 'warning');
              } else {
                return this.openSnackBar(
                  'Sistema indisponível. Estamos trabalhando para resolver. Por favor, tente novamente mais tarde.',
                  'error'
                );
              }
            },
          });
        }
       
      }
    })


  }

  onGetContract(contractId: any) {
    this.contractService
      .getContract(contractId)
      .pipe(
        take(1),
        finalize(() => {
          this.loadingService.hideLoading();
        })
      )
      .subscribe({
        next: (res: any) => {
          this.contract = res;
          this.concessionType = res.concessionType.name;
          
          this.intervenientesList = res.intervenientes;
          this.anotacoesList = res.anotacoes;
          this.dataSourceEntitieTable = new MatTableDataSource(
            res.intervenientes
          );
          this.cdr.detectChanges();
          if(!this.onInit){
            this.selectedTabIndex = 0;
            this.onInit = true;
          }
         
          
        },
        error: (erro: any) => {
          if (erro.status !== 500 && erro.status) {
            return this.openSnackBar(erro.error.message, 'error');
          }
          if (erro.error.error == 'Unprocessable Entity') {
            return this.openSnackBar(erro.error.message, 'warning');
          } else {
            return this.openSnackBar(
              'Sistema indisponível. Estamos trabalhando para resolver. Por favor, tente novamente mais tarde.',
              'error'
            );
          }
        },
      });
  }
  onGetIntervenier(contractId: any, tipoEntidade?:any, entidade?: any) {
    this.intervienteService
      .getAllIntervenientes(this.pageIndex, contractId, this.sortState.sortDirection, this.sortState.sortProperty, tipoEntidade, entidade)
      .pipe(
        take(1),
        finalize(() => {
          this.loadingService.hideLoading();
        })
      )
      .subscribe({
        next: (res: any) => {
          const { content, pageSize, totalPages, totalElements, pageNumber } =
            res;
          this.dataSourceEntitieTable.data = content;

          this.pageSize = pageSize;
          this.totalPages = totalPages;
          this.totalElements = totalElements;
          this.pageIndex = pageNumber;
        },
        error: (erro: any) => {
          if (erro.error.message === 'Nenhum interveniente encontrado.') {
            this.dataSourceEntitieTable.data = [];
          } else {
            return this.openSnackBar(
              'Sistema indisponível. Estamos trabalhando para resolver. Por favor, tente novamente mais tarde.',
              'error'
            );
          }
        },
      });
  }


  onSortChange(
    sortProperty: 'entidade.tipoEntidade.nome' | 'nome' | 'entidade.razaoSocial' | 'entidade.cnpj' | 'status'
  ): void {
    if (this.sortState.sortProperty === sortProperty) {
      this.sortState.sortDirection =
        this.sortState.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortState.sortDirection = 'asc';
    }
  
    this.sortState.sortProperty = sortProperty;
    this.onGetIntervenier(this.contract_id, this.selectedOptionEntidadeIntervenientes, this.selectedOptionTipoEntidadeIntervenientes)
  }

  onSortChangeDocument(
    sortProperty: 'tipoDocumento.nome' | 'descricao' | 'nomeArquivo' | 'dataCriacao' | 'usuarioCriacao'
  ): void {
    if (this.sortStateDocument.sortProperty === sortProperty) {
      this.sortStateDocument.sortDirection =
        this.sortStateDocument.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortStateDocument.sortDirection = 'asc';
    }
    this.sortStateDocument.sortProperty = sortProperty;

    this.getDocuments()
  }
  onSortChangeAnotation(
    sortProperty: 'nomeTipoDocumento' | 'descricao' | 'anexo' | 'dataCriacaoInical' | 'usuarioCriacao'
  ): void {
    if (this.sortStateDocument.sortProperty === sortProperty) {
      this.sortState.sortDirection =
        this.sortState.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortStateDocument.sortDirection = 'asc';
    }
    this.sortStateDocument.sortProperty = sortProperty;

    this.getDocuments()
  }

  onOptionSelectedTipoEntidadeIntervenientes(event: any) {
    this.selectedOptionTipoEntidadeIntervenientes = event.value;

    this.searchControlTipoEntidadeIntervenientes.setValue(
      this.selectedOptionTipoEntidadeIntervenientes || '',
      { emitEvent: false }
    );
    this.onGetIntervenier(this.contract_id, this.selectedOptionEntidadeIntervenientes, this.selectedOptionTipoEntidadeIntervenientes)

  }

  onOptionSelectedEntidadeIntervenientes(event: any) {
    this.selectedOptionEntidadeIntervenientes = event.value;

    this.searchControlEntidadeIntervenientes.setValue(
      this.selectedOptionEntidadeIntervenientes || '',
      { emitEvent: false }
    );
    this.onGetIntervenier(this.contract_id, this.selectedOptionEntidadeIntervenientes, this.selectedOptionTipoEntidadeIntervenientes)

  }

  ngAfterViewInit() {
    // Força a ativação de todas as abas para carregar o conteúdo
    const originalIndex = this.tabGroup.selectedIndex;

    for (let i = 0; i < this.tabGroup._tabs.length; i++) {
      this.tabGroup.selectedIndex = i;
    }

    // Retorna à aba original
    this.tabGroup.selectedIndex = originalIndex;
  }
  changeStatusIntervenientes(interveniente: any) {
    if (this.contract_id) {
      if (interveniente.status) {
        this.openInactivateDialog(interveniente.id);
      } else {
        this.openActivateDialog(interveniente.id);
      }
    }
  }

  openInactivateDialog(id: any): void {
    const modalTitle: string = 'Inativar';
    const modalContent: string =
      'Você tem certeza que deseja inativar este interveniente?';

    const dialogRef = this.dialog.open(ModalComponent, {
      data: {
        onPerformAction: this.onInactivateModalConfirm.bind(this),
        modalTitle: modalTitle,
        modalContent: modalContent,
        id: id,
      },
    });

    dialogRef.afterClosed().subscribe({
      next: (res: any) => {
        const idContrato: any = this.contract_id;
        this.intervenientesList.find((interv) => interv.id == id).status =
          false;
        this.openSnackBar('Status do documento alterado!', 'sucess');
        this.loadingService.hideLoading();
      },
    });
  }

  deletedIntervenients(entitie: any) {
    const modalTitle: string = 'Excluir';
    const modalContent: string =
      'Você tem certeza que deseja excluir esta Entidade?';

    const dialogRef = this.dialog.open(ModalComponent, {
      data: {
        onPerformAction: this.onDeleteModalConfirmIntervenients.bind(this),
        modalTitle: modalTitle,
        modalContent: modalContent,
        id: entitie.id,
      },
    });
  }

  getDocuments() {
    this.loadingService.showLoading();
    this.documentServices
      .getDocumentVinculatedContract(
        this.contract_id,
        this.pageIndexDocument,
        this.sortStateDocument.sortProperty,
        this.sortStateDocument.sortDirection
      )
      .pipe(
        take(1),
        finalize(() => {
          this.loadingService.hideLoading();
        })
      )
      .subscribe({
        next: (res: any) => {
          this.dataSourceEntitieTableDocument.data = res.content;
          this.dataSourceEntitieTableDocument.paginator =
            this.paginatorDocument;
          this.pageSizeDocument = res.length;
          this.pageIndexDocument = res.pageNumber;
          this.totalElementsDocument = res.totalElements;
        },
        error: (err: any) => {
          if (err.error.message === 'Nenhum documento encontrado.') {
            this.dataSourceEntitieTableDocument.data = [];
          } else {
            this.openSnackBar(err.message, 'error');
          }
        },
      });
  }

  downloadFile(doc: any) {

    this.documentServices
    .downloadDocument(this.contract_id, doc)
    .pipe(
      take(1),
      finalize(() => {
        this.loadingService.hideLoading();
      })
    )
    .subscribe(
      (response: any) => {
        this.documentServices.convertBlobAndDownload(response);
      },
      (erro: any) => {
        if (erro.status !== 500 && erro.status) {
          this.toastService.showError(erro.error.message);
        } else {
          this.toastService.showError();
        }
      }
    );
  }

  openAnnotationAdd() {
    const data = {
      isDocument: false,
      isAnotation: true,
    };
    const dialogRef = this.dialog.open(UploadModalComponent, {
      panelClass: ['anotation-panel'],
      data,
    });

    dialogRef.afterClosed().subscribe({
      next: (res: any) => {
        if (res) {
          const anotation = {
            dataCadastro: new Date(),
            usuario: 'e888eb4d-0eef-4af0-8b5f-80f3e28e6605',
            descricao: res.descricao,
          };

          this.annotationService
            .postAnotation(this.contract_id, anotation)
            .pipe(
              finalize(() => {
                this.loadingService.hideLoading();
              })
            )
            .subscribe({
              next: (res: any) => {
                this.onGetAllAnotation();
                this.openSnackBar('Anotação adicionado com sucesso.', 'sucess');
              },
              error: (err: any) => {
                this.openSnackBar(err.error.message, 'error');
              },
            });
        }
      },
    });
  }

  editAnnotation(annotation: any) {
    const data = {
      isDocument: false,
      isAnotation: true,
      annotation: annotation,
      isEditMode: true,
    };
    const dialogRef = this.dialog.open(UploadModalComponent, {
      panelClass: ['anotation-panel'],
      data,
    });

    dialogRef.afterClosed().subscribe({
      next: (res: any) => {
        if (res) {
          this.annotationService
            .putAnotation(this.contract_id, res.id, res)
            .pipe(
              finalize(() => {
                this.loadingService.hideLoading();
              })
            )
            .subscribe({
              next: (res: any) => {
                this.onGetAllAnotation();
                this.openSnackBar('Anotação adicionado com sucesso.', 'sucess');
              },
              error: (err: any) => {
                this.openSnackBar(err.error.message, 'error');
              },
            });
        }
      },
    });
  }

  deleteAnnotation(annotation: any) {
    const modalTitle: string = 'Excluir';
    const modalContent: string =
      'Você tem certeza que deseja excluir esta Anotação?';

    const dialogRef = this.dialog.open(ModalComponent, {
      data: {
        onPerformAction: this.onDeleteModalConfirmAnnotation.bind(this),
        modalTitle: modalTitle,
        modalContent: modalContent,
        id: annotation,
      },
    });
  }

  onGetAllAnotation(pageIndex: number = 0) {
    this.annotationService
      .getAnotations(
        pageIndex,
        this.contract_id,
        this.sortState.sortDirection,
        'id',
        this.descricao
      )
      .pipe(
        finalize(() => {
          this.loadingService.hideLoading();
        })
      )
      .subscribe({
        next: (res: any) => {
          const { content, pageSize, totalPages, totalElements, pageNumber } =
            res;
          this.dataSourceAnnotation.data = content;
          this.pageSizeAnotation = pageSize;
          this.totalPagesAnotation = totalPages;
          this.totalElementsAnotation = totalElements;
          this.pageIndexAnotation = pageNumber;
        },
        error: (err: any) => {
          if (err.error.message === 'Nenhuma anotação encontrada.') {
            this.dataSourceAnnotation.data = [];
          } else {
            this.openSnackBar(err.error.message, 'error');
          }
        },
      });
  }

  onDeleteModalConfirmAnnotation(id: any): void {
    this.annotationService
      .deleteAnotation(this.contract_id, id.id)
      .pipe(
        finalize(() => {
          this.loadingService.hideLoading();
        })
      )
      .subscribe({
        next: (res: any) => {
          this.onGetAllAnotation();
          this.openSnackBar('Anotação Deletado com sucesso.', 'sucess');
        },
        error: (err: any) => {
          this.openSnackBar(err.error.message, 'error');
        },
      });
  }

  deleteDocument(document: any) {
    const modalTitle: string = 'Excluir';
    const modalContent: string =
      'Você tem certeza que deseja excluir este documento?';

    const dialogRef = this.dialog.open(ModalComponent, {
      data: {
        onPerformAction: this.onDeleteModalConfirm.bind(this),
        modalTitle: modalTitle,
        modalContent: modalContent,
        id: document.id,
      },
    });
  }

  pageChangeEventDocument(event: PageEvent) {
    if (this.pageIndexDocument !== event.pageIndex) {
      this.onGetEntitiesIntervenientes(event.pageIndex);
    }
  }



  editDocument(document: any) {
    const data = {
      isDocument: true,
      isAnotation: false,
      isEditMode: true,
      document: document,
      contract_id: this.contract_id
    };
    const dialogRef = this.dialog.open(UploadModalComponent, {
      panelClass: ['filter-panel'],
      data,
    });

    dialogRef.afterClosed().subscribe({
      next: (res: any) => {
        if (res) {
          this.loadingService.showLoading();
          this.documentServices
            .updatedDocumentVinculatedContract(
              this.contract_id,
              document.id,
              res,
              this.contract?.company
            )
            .pipe(
              take(1),
              finalize(() => {
                this.loadingService.hideLoading();
              })
            )
            .subscribe({
              next: (res: any) => {
                this.openSnackBar('Documento editado com sucesso!', 'sucess');
                this.getDocuments();
              },
              error: (erro: any) => {
                if (erro.status !== 500 && erro.status) {
                  return this.openSnackBar(erro.error.message, 'error');
                }
                if (erro.error.error == 'Unprocessable Entity') {
                  return this.openSnackBar(erro.error.message, 'warning');
                } else {
                  return this.openSnackBar(
                    'Sistema indisponível. Estamos trabalhando para resolver. Por favor, tente novamente mais tarde.',
                    'error'
                  );
                }
              },
            });
        }
      },
    });
  }

  openDocumentAdd() {
    const data = {
      isDocument: true,
      isAnotation: false,
    };
    const dialogRef = this.dialog.open(UploadModalComponent, {
      panelClass: ['filter-panel'],
      data,
    });

    dialogRef.afterClosed().subscribe({
      next: (res: any) => {
        if (res) {
          this.loadingService.showLoading();
          this.documentServices
            .createDocumentVinculatedContract(this.contract_id, res, this.contract?.company)
            .pipe(
              take(1),
              finalize(() => {
                this.loadingService.hideLoading();
              })
            )
            .subscribe({
              next: (res: any) => {
                this.openSnackBar('Documento criado com sucesso!', 'sucess');
                this.getDocuments();
              },
              error: (erro: any) => {
                if (erro.status !== 500 && erro.status) {
                  return this.openSnackBar(erro.error.message, 'error');
                }
                if (erro.error.error == 'Unprocessable Entity') {
                  return this.openSnackBar(erro.error.message, 'warning');
                } else {
                  return this.openSnackBar(
                    'Sistema indisponível. Estamos trabalhando para resolver. Por favor, tente novamente mais tarde.',
                    'error'
                  );
                }
              },
            });
        }
      },
    });
  }

  onDeleteModalConfirmIntervenients(id: any): void {
    this.loadingService.showLoading();
    this.intervienteService
      .deleteIntervenientes(this.contract_id, id)
      .pipe(
        take(1),
        finalize(() => {
          this.loadingService.hideLoading();
        })
      )
      .subscribe({
        next: (res: any) => {
          this.openSnackBar('Entidade deletada  com sucesso!', 'sucess');
          this.onGetIntervenier(this.contract_id, this.selectedOptionEntidadeIntervenientes, this.selectedOptionTipoEntidadeIntervenientes);
        },
        error: (erro: any) => {
          if (erro.status !== 500 && erro.status) {
            return this.openSnackBar(erro.error.message, 'error');
          }
          if (erro.error.error == 'Unprocessable Entity') {
            return this.openSnackBar(erro.error.message, 'warning');
          } else {
            return this.openSnackBar(
              'Sistema indisponível. Estamos trabalhando para resolver. Por favor, tente novamente mais tarde.',
              'error'
            );
          }
        },
      });
  }

  openActivateDialog(id: any): void {
    const modalTitle: string = 'Ativar';
    const modalContent: string =
      'Você tem certeza que deseja ativar este interveniente?';

    const dialogRef = this.dialog.open(ModalComponent, {
      data: {
        onPerformAction: this.onActivateModalConfirm.bind(this),
        modalTitle: modalTitle,
        modalContent: modalContent,
        id: id,
      },
    });
    dialogRef.afterClosed().subscribe({
      next: (res: any) => {
        const idContrato: any = this.contract_id;
        this.intervenientesList.find((interv) => interv.id == id).status = true;
        this.openSnackBar('Status do documento alterado!', 'sucess');
        this.loadingService.hideLoading();
      },
    });
  }
   onActivateModalConfirm(id: any): void {
    this.loadingService.showLoading();
    let data = {
      idContrato: this.contract_id,
      idInterveniente: id,
    };

    this.intervienteService
      .AtivarIntervenientes(this.contract_id, id, data)
      .pipe(
        take(1),
        finalize(() => {
          this.loadingService.hideLoading();
        })
      )
      .subscribe({
        next: (res: any) => {
          this.openSnackBar('Entidade Ativada  com sucesso!', 'sucess');
          this.onGetIntervenier(this.contract_id);
        },
        error: (erro: any) => {
          if (erro.status !== 500 && erro.status) {
            return this.openSnackBar(erro.error.message, 'error');
          }
          if (erro.error.error == 'Unprocessable Entity') {
            return this.openSnackBar(erro.error.message, 'warning');
          } else {
            return this.openSnackBar(
              'Sistema indisponível. Estamos trabalhando para resolver. Por favor, tente novamente mais tarde.',
              'error'
            );
          }
        },
      });
  }

    onDeleteModalConfirm(id: any): void {
    this.loadingService.showLoading();
    this.documentServices
      .deleteDocumentVinculatedContract(this.contract_id, id)
      .pipe(
        take(1),
        finalize(() => {
          this.loadingService.hideLoading();
        })
      )
      .subscribe({
        next: (res: any) => {
          this.getDocuments();
          this.openSnackBar('Documento deletado com sucesso!', 'sucess');
        },
        error: (erro: any) => {
          if (erro.status !== 500 && erro.status) {
            return this.openSnackBar(erro.error.message, 'error');
          }
          if (erro.error.error == 'Unprocessable Entity') {
            return this.openSnackBar(erro.error.message, 'warning');
          } else {
            return this.openSnackBar(
              'Sistema indisponível. Estamos trabalhando para resolver. Por favor, tente novamente mais tarde.',
              'error'
            );
          }
        },
      });
  }
  onInactivateModalConfirm(id: any): void {
    this.loadingService.showLoading();
    let data = {
      idContrato: this.contract_id,
      idInterveniente: id,
    };

    this.intervienteService
      .inativarIntervenientes(this.contract_id, id, data)
      .pipe(
        take(1),
        finalize(() => {
          this.loadingService.hideLoading();
        })
      )
      .subscribe({
        next: (res: any) => {
          this.openSnackBar('Entidade Inativada  com sucesso!', 'sucess');
          this.onGetIntervenier(this.contract_id);
        },
        error: (erro: any) => {
          if (erro.status !== 500 && erro.status) {
            return this.openSnackBar(erro.error.message, 'error');
          }
          if (erro.error.error == 'Unprocessable Entity') {
            return this.openSnackBar(erro.error.message, 'warning');
          } else {
            return this.openSnackBar(
              'Sistema indisponível. Estamos trabalhando para resolver. Por favor, tente novamente mais tarde.',
              'error'
            );
          }
        },
      });
  }
 
  async openDialogHistoricoDocumento(contract_id: any, documentId: string){

        const data = {
          type: 'documento',
          id: contract_id,
          documentId: documentId,
          fieldMappings: {
            id: 'Id',
            tipoDocumento: 'Tipo',
            descricao: 'Descrição',
            nomeArquivo: 'Anexo',
            dataCriacao: 'Data de Cadastro',
            dataEdicao: 'Data de Edição',
            usuarioEdicao: 'Usuário',
            usuarioCriacao: 'Usuário'
          }
        }
        const modal = await this.modalCtrl.create({
          component: ModalHistoricComponent,
          componentProps: {
            data: data,
            fieldMappings: data.fieldMappings,
          },
        });
    
        modal.present();
  }

  async openDialogHistoricoInterveniente(contract_id: any, entitieId: string){

    const data = {
      type: 'interveniente',
      id: contract_id,
      entitieId: entitieId,
      fieldMappings: {
        nome: 'Tipo de entidade',
        razaoSocial: 'Razão Social',
        cnpj: 'CNPJ',
        status: 'Situação',
        usuarioCriacao: 'Usuário'
      }
    }
    const modal = await this.modalCtrl.create({
      component: ModalHistoricComponent,
      componentProps: {
        data: data,
        fieldMappings: data.fieldMappings,
      },
    });

    modal.present();
  }

  async openDialogHistoricoAnotacao(contract_id: any, entitieId: string){

    const data = {
      type: 'anotacao',
      id: contract_id,
      entitieId: entitieId,
      fieldMappings: {
        descricao: 'Descrição',
      }
    }
    const modal = await this.modalCtrl.create({
      component: ModalHistoricComponent,
      componentProps: {
        data: data,
        fieldMappings: data.fieldMappings,
      },
    });

    modal.present();
  }

  selectTypeEntity(typeEntitieName: string) {
    this.selectedOptionTipoEntidadeIntervenientes = typeEntitieName;
  }

  selectEntity(entitieName: string) {
    this.selectedOptionEntidadeIntervenientes = entitieName;
  }

  getPrazoAnaliseProjeto() {
    this.contractService
      .getPrazoAnaliseProjeto(this.contract_id)
      .pipe(take(1), finalize(() => this.loadingService.hideLoading()))
      .subscribe({
        next: (res: any) => {
          if (res) {
            this.prazosForm.patchValue({
              prazoAnaliseFuncional: res.prazoAnaliseFuncional,
              prazoAnaliseExecutivo: res.prazoAnaliseExecutivo,
            });
          }
        },
        error: (err: any) => {
          if (err.status !== 404) {
            this.openSnackBar('Erro ao carregar prazos de análise.', 'error');
          }
        },
      });
  }

  savePrazoAnaliseProjeto() {
    const data = {
      prazoAnaliseFuncional: this.prazosForm.value.prazoAnaliseFuncional,
      prazoAnaliseExecutivo: this.prazosForm.value.prazoAnaliseExecutivo,
    };
    this.loadingService.showLoading();
    this.contractService
      .savePrazoAnaliseProjeto(this.contract_id, data)
      .pipe(take(1), finalize(() => this.loadingService.hideLoading()))
      .subscribe({
        next: () => {
          this.openSnackBar('Prazos salvos com sucesso!', 'sucess');
        },
        error: (err: any) => {
          this.openSnackBar(err.error?.message || 'Erro ao salvar prazos.', 'error');
        },
      });
  }

  async openDialogHistoricoPrazoAnaliseProjeto() {
    const data = {
      type: 'prazoAnaliseProjeto',
      id: this.contract_id,
      fieldMappings: {
        prazoAnaliseFuncional: 'Funcional (dias)',
        prazoAnaliseExecutivo: 'Executivo (dias)',
      },
    };
    const modal = await this.modalCtrl.create({
      component: ModalHistoricComponent,
      componentProps: {
        data: data,
        fieldMappings: data.fieldMappings,
      },
    });
    modal.present();
  }

}
